import React, { useMemo, useState } from 'react';
import './LoginForm.css';

const DEFAULT_PASSWORD_ROLES = {
  enzo10: 'admin',
  Gianni58: 'admin'
};

const DEFAULT_LABELS = {
  title: 'Villa Pina e Paolo',
  placeholder: 'Entrez le mot de passe',
  submit: 'Accéder',
  errorInvalid: 'Mot de passe incorrect'
};

const LoginForm = ({ onLogin, passwordRoles, labels }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const effectiveLabels = useMemo(() => {
    return { ...DEFAULT_LABELS, ...(labels || {}) };
  }, [labels]);

  const rolesByPassword = useMemo(() => {
    return passwordRoles && typeof passwordRoles === 'object'
      ? passwordRoles
      : DEFAULT_PASSWORD_ROLES;
  }, [passwordRoles]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const role = rolesByPassword[password];

    if (role) {
      setError('');
      onLogin(role);
    } else {
      setError(effectiveLabels.errorInvalid);
      setPassword('');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>{effectiveLabels.title}</h1>
        <form onSubmit={handleSubmit}>
          <div className="login-password-wrap">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder={effectiveLabels.placeholder}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
            <button
              type="button"
              className="login-eye-btn"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}
            >
              👁️
            </button>
          </div>
          <button type="submit">{effectiveLabels.submit}</button>
        </form>
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
};

export default LoginForm;
